'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var vertical = exports.vertical = {
  direction: 'vertical',
  line: 'y',
  crossLine: 'x',
  start: 'top',
  end: 'bottom',
  size: 'height',
  crossAxisStart: 'left',
  crossAxisEnd: 'right',
  crossAxisSize: 'width'
};

var horizontal = exports.horizontal = {
  direction: 'horizontal',
  line: 'x',
  crossLine: 'y',
  start: 'left',
  end: 'right',
  size: 'width',
  crossAxisStart: 'top',
  crossAxisEnd: 'bottom',
  crossAxisSize: 'height'
};


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/state/axis.js
// module id = 502
// module chunks = 0